import { DataService } from '../../../shared/dataservice.service';
import { Component, OnInit, Input } from '@angular/core';
import { SalesOrder, SubSalesOrder, SOStatus, SSOStatus, monthFilter, PmTechnicalIP,  UiFunctionalKPI } from '../../../shared/misc-classes';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { KPIChartService } from '../../../shared/kpi-charts-service';
import * as Highcharts from 'highcharts';

@Component({
  selector: 'app-quality-kpi',
  templateUrl: './quality-kpi.component.html',
  styleUrls: ['./quality-kpi.component.css']
})
export class QualityKpiComponent implements OnInit {

  @Input() pmTechSSO: PmTechnicalIP;
  soObj: SalesOrder;
  _soObjListKpi9: Array<SalesOrder>;

  filteredSOCount: number = 0;
  filteredSSOCount: number = 0;
  isDataViewUpdated4: boolean = false;
  isLoading: boolean = false;
  QualityKpi: Array<UiFunctionalKPI> = [];


  isManfMonthFilterSelectedKpi9: boolean = false;
  manfMonthFilterKpi9: monthFilter;

  Highcharts = Highcharts;

  totalDataME: any;
  totalDataKpiChartOptionsME: Highcharts.Options;
  panelWiseDataME: any;
  panelWiseKpiChartOptionsME: Highcharts.Options;

  totalDataFAT: any;
  totalDataKpiChartOptionsFAT: Highcharts.Options;
  panelWiseDataFAT: any;
  panelWiseKpiChartOptionsFAT: Highcharts.Options;

  totalDataGS: any;
  totalDataKpiChartOptionsGS: Highcharts.Options;
  panelWiseDataGS: any;
  panelWiseKpiChartOptionsGS: Highcharts.Options;

  
  constructor(public _dataService: DataService, public dialog: MatDialog,
    private _kpiCharServ: KPIChartService) { }

  ngOnInit() {
    try {
      this.loadSettingsFromCookies();
    } catch (e) {
      console.log(e);
    }

    this.loadData();
  }
  saveSettingsToCookies() {
    this._dataService.setCookie('s-manfmonth-sel-kpi-10', this.isManfMonthFilterSelectedKpi9 ? "1" : "0");
    if (this.isManfMonthFilterSelectedKpi9) {
      this._dataService.setCookie('s-manfmonth-val-kpi-10', this.manfMonthFilterKpi9.getCookieStr());
    }
  }
  loadSettingsFromCookies() {


    let _tmpManfMonthSel: string = this._dataService.getCookie('s-manfmonth-sel-kpi-10');
    if (_tmpManfMonthSel) {
      this.isManfMonthFilterSelectedKpi9 = (_tmpManfMonthSel == "1");

      let _tmpManfMonthVal: string = this._dataService.getCookie('s-manfmonth-val-kpi-10');
      if (_tmpManfMonthVal) {
        this.manfMonthFilterKpi9= monthFilter.getObjFromCookieStr(_tmpManfMonthVal);
      }
    }


    let _currDate: Date = new Date();
    if (this.manfMonthFilterKpi9 == null) {
      this.manfMonthFilterKpi9 = new monthFilter(_currDate.getMonth() + 1, _currDate.getFullYear(),
        _currDate.getMonth() + 1, _currDate.getFullYear());
    }

  }
  loadData() {
    this.isLoading = true;
    this._dataService.getDataDefinitions().subscribe(res => {
      this._dataService.getAllSalesOrder(1).subscribe((_soObjAr: Array<SalesOrder>) => {
        this._soObjListKpi9 = _soObjAr.filter((_tmpSO2: SalesOrder) => {
          //test the filter.
          // if(_tmpSO2.projectStatus == SOStatus.Dispatched || _tmpSO2.projectStatus == SOStatus.Archived)
          if (_tmpSO2.projectStatus == SOStatus.Dispatched) {
            return false;
          }
          return true;
        });
        this.filterRows();
      });
    });
  }

  getClassName(_temp: number): string {
    if (_temp < 6) {
      return "bg-grey";
    } else if (_temp >= 6 && _temp < 10) {
      return "bg-yellow";
    } else if (_temp > 10) {
      return "bg-green";
    }
  }



  reloadData(): void {
    this.isLoading = true;
    this.loadData();
  }
  clearFilters(): void {

    this.isManfMonthFilterSelectedKpi9 = false;
    this.isLoading = true;
    this.loadData();

    setTimeout(() => {
      this.saveSettingsToCookies();
    }, 10);
  }



  filterRows(): void {
    this.isLoading = true;
    setTimeout(() => {
      this.filterRowsLogic2();
      this.isLoading = false;
    }, 5);
    this.saveSettingsToCookies();
  }


  private displaySOwithNoSSO() {
    if (this.isManfMonthFilterSelectedKpi9 == true

    ) {
      return false;
    }

    return true;
  }


  filterRowsLogic2() {
    let _tmpSOCounter: number = 0;
    let _tmpSSOCounter: number = 0;
    let _tmpQualityKpi: Array<UiFunctionalKPI> = [];

    let _totalQtyME: number = 0;
    let _delayQtyME: number = 0;
    let _onTimeQtyME: number = 0;
    let _delayQtyMEZS1: number = 0;
    let _onTimeQtyMEZS1: number = 0;
    let _delayQtyMEZS1DBB: number = 0;
    let _onTimeQtyMEZS1DBB: number = 0;
    let _delayQtyMEZS2: number = 0;
    let _onTimeQtyMEZS2: number = 0;
    let _delayQtyMEZS9: number = 0;
    let _onTimeQtyMEZS9: number = 0;
    let _delayQtyMEZN1: number = 0;
    let _onTimeQtyMEZN1: number = 0;

    let _totalQtyFAT: number = 0;
    let _delayQtyFAT: number = 0;
    let _onTimeQtyFAT: number = 0;
    let _delayQtyFATZS1: number = 0;
    let _onTimeQtyFATZS1: number = 0;
    let _delayQtyFATZS1DBB: number = 0;
    let _onTimeQtyFATZS1DBB: number = 0;
    let _delayQtyFATZS2: number = 0;
    let _onTimeQtyFATZS2: number = 0;
    let _delayQtyFATZS9: number = 0;
    let _onTimeQtyFATZS9: number = 0;
    let _delayQtyFATZN1: number = 0;
    let _onTimeQtyFATZN1: number = 0;

    let _totalQtyGS: number = 0;
    let _delayQtyGS: number = 0;
    let _onTimeQtyGS: number = 0;
    let _delayQtyGSZS1: number = 0;
    let _onTimeQtyGSZS1: number = 0;
    let _delayQtyGSZS1DBB: number = 0;
    let _onTimeQtyGSZS1DBB: number = 0;
    let _delayQtyGSZS2: number = 0;
    let _onTimeQtyGSZS2: number = 0;
    let _delayQtyGSZS9: number = 0;
    let _onTimeQtyGSZS9: number = 0;
    let _delayQtyGSZN1: number = 0;
    let _onTimeQtyGSZN1: number = 0;

   

    let _equpList = ["001", "002", "037", "003", "004", "005", "006", "007", "008", "009", "010", "011", "012", "013", "014", "015", "016", "017", "018"];

    let _showSOWithNoSSO: boolean = this.displaySOwithNoSSO();

    for (var i = 0; i < this._soObjListKpi9.length; i++) {
      let _tmpSO: SalesOrder = this._soObjListKpi9[i];

      let _isSOPassedFilter: boolean = true;
      if (_isSOPassedFilter == true) {
        let _filteredSSO: Array<SubSalesOrder> = this.getFilteredSubOrders(_tmpSO.subSalesOrder);

        if (_filteredSSO.length > 0 || (_tmpSO.subSalesOrder.length == 0 && _showSOWithNoSSO == true)) {

          let _tmpSSOobj: UiFunctionalKPI;

          _tmpSOCounter++;

          _filteredSSO.forEach((_tmpSSO: SubSalesOrder) => {

            

            // Check for Mechanical/electrical testing planned and Actual Dates      

            if (_tmpSSO.qualityIP.mechanicalElectricalTestingActualDate != null) {
              let _meActual = _tmpSSO.qualityIP.mechanicalElectricalTestingActualDate.getTime();
              let _isRevised = null;
              let _isRequested;
              let _meOtherDate;
              if( _tmpSSO.qualityIP.mechanicalElectricalTestingRequestedDate==null){
                _isRequested = false;
                _meOtherDate = _tmpSSO.qualityIP.mechanicalElectricalTestingPlannedDate.getTime();
                _isRevised = _tmpSSO.qualityIP.mechanicalElectricalTestingPlannedDateIsRevised;
            }
            else{
              _isRequested = true;
              _meOtherDate = _tmpSSO.qualityIP.mechanicalElectricalTestingRequestedDate.getTime();
            }
            _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
              if (_equpList.includes(e.equipmentType)) {
                var temp: number = parseInt(e.panelQuantity, 10);
                if (temp > 0) {
                  _totalQtyME += temp;
                  
                  
                }
              }
            });
              let _meDiff_time =  _meOtherDate - _meActual;
              let _meDiff = _meDiff_time / (1000 * 3600 * 24);
              ///Mechanical/electrical testing Finalization Delay
              if (_meDiff < 0) {
                _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                  if (_equpList.includes(e.equipmentType)) {
                    var temp: number = parseInt(e.panelQuantity, 10);
                    if (temp > 0) {
                      _delayQtyME += temp;
                    }
                  }
                });

                let _individualDelayQtyME = 0;
                switch (_tmpSSO.pmTechSubSalesOrder.productVarient) {
                  case "001":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _delayQtyMEZS1 += temp;
                          _individualDelayQtyME += temp;
                        }
                      }
                    });
                    break;
                  case "002":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _delayQtyMEZS1DBB += temp;
                          _individualDelayQtyME += temp;
                        }
                      }
                    });

                    break;
                  case "003":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _delayQtyMEZS2 += temp;
                          _individualDelayQtyME += temp;
                        }
                      }
                    });

                    break;
                  case "004":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _delayQtyMEZN1 += temp;
                          _individualDelayQtyME += temp;
                        }
                      }
                    });

                    break;
                  case "005":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _delayQtyMEZS9 += temp;
                          _individualDelayQtyME += temp;
                        }
                      }
                    });
                    break;
                }
                let _plannedTmp;
                let _revisedTmp;
                if(_isRevised!=null){
                  if(_isRevised == true){
                    _plannedTmp = null;
                    _revisedTmp = _tmpSSO.qualityIP.mechanicalElectricalTestingPlannedDate;
                  }
                  else{
                    _plannedTmp = _tmpSSO.qualityIP.mechanicalElectricalTestingPlannedDate;
                    _revisedTmp = null;
                  }
                }
                else{
                  _plannedTmp = null;
                  _revisedTmp = null;
                }
                let _requestedTmp = _isRequested==false?null:_tmpSSO.qualityIP.mechanicalElectricalTestingRequestedDate;

                _tmpSSOobj = new UiFunctionalKPI(_tmpSSO.planningIP.plannedManufacturingMonth, 'Mechanical/electrical testing',_tmpSO.marketingIP.customerName , _tmpSO.marketingIP.salesOrderNo, _tmpSSO.subOrderNoId,
                _tmpSO.pmCommercial.isSaleOrderChangeApplicable, _tmpSO.pmCommercial.salesOrderNoNew, this._dataService.getProductVariantName(_tmpSSO.pmTechSubSalesOrder.productVarient), _individualDelayQtyME, _plannedTmp, _revisedTmp,
                _requestedTmp, _tmpSSO.qualityIP.mechanicalElectricalTestingActualDate, _meDiff, _tmpSSO.qualityIP.mechanicalElectricalTestingActualToken.addNotes)
                
                _tmpQualityKpi.push(_tmpSSOobj);
              }
              // Mechanical/electrical testing Finalization on Time
              if (_meDiff >= 0) {
                _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                  if (_equpList.includes(e.equipmentType)) {
                    var temp: number = parseInt(e.panelQuantity, 10);
                    if (temp > 0) {
                      _onTimeQtyME += temp;
                    }
                  }
                });

                let _individualOnTimeQtyME = 0;
                switch (_tmpSSO.pmTechSubSalesOrder.productVarient) {
                  case "001":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _onTimeQtyMEZS1 += temp;
                          _individualOnTimeQtyME += temp;
                        }
                      }
                    });
                    break;
                  case "002":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _onTimeQtyMEZS1DBB += temp;
                          _individualOnTimeQtyME += temp;
                        }
                      }
                    });

                    break;
                  case "003":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _onTimeQtyMEZS2 += temp;
                          _individualOnTimeQtyME += temp;
                        }
                      }
                    });

                    break;
                  case "004":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _onTimeQtyMEZN1 += temp;
                          _individualOnTimeQtyME += temp;
                        }
                      }
                    });

                    break;
                  case "005":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _onTimeQtyMEZS9 += temp;
                          _individualOnTimeQtyME += temp;
                        }
                      }
                    });
                    break;
                }
                let _plannedTmp;
                let _revisedTmp;
                if(_isRevised!=null){
                  if(_isRevised == true){
                    _plannedTmp = null;
                    _revisedTmp = _tmpSSO.qualityIP.mechanicalElectricalTestingPlannedDate;
                  }
                  else{
                    _plannedTmp = _tmpSSO.qualityIP.mechanicalElectricalTestingPlannedDate;
                    _revisedTmp = null;
                  }
                }
                else{
                  _plannedTmp = null;
                  _revisedTmp = null;
                }
                let _requestedTmp = _isRequested==false?null:_tmpSSO.qualityIP.mechanicalElectricalTestingRequestedDate;

                _tmpSSOobj = new UiFunctionalKPI(_tmpSSO.planningIP.plannedManufacturingMonth, 'Mechanical/electrical testing',_tmpSO.marketingIP.customerName , _tmpSO.marketingIP.salesOrderNo, _tmpSSO.subOrderNoId,
                _tmpSO.pmCommercial.isSaleOrderChangeApplicable, _tmpSO.pmCommercial.salesOrderNoNew, this._dataService.getProductVariantName(_tmpSSO.pmTechSubSalesOrder.productVarient), _individualOnTimeQtyME, _plannedTmp, _revisedTmp,
                _requestedTmp, _tmpSSO.qualityIP.mechanicalElectricalTestingActualDate, _meDiff, _tmpSSO.qualityIP.mechanicalElectricalTestingActualToken.addNotes)
                
                    _tmpQualityKpi.push(_tmpSSOobj);
              }  


            }

            // Check for FAT requested date Planned and Actual Dates

            if (_tmpSSO.qualityIP.fatActualDate != null) {
              let _fatActual = _tmpSSO.qualityIP.fatActualDate.getTime();
              let _isRevised = null;
              let _isRequested;
              let _fatOtherDate;
              if( _tmpSSO.qualityIP.fatRequestedDate==null){
                _isRequested = false;
                _fatOtherDate = _tmpSSO.qualityIP.fatPlannedDate.getTime();
                _isRevised = _tmpSSO.qualityIP.fatPlannedDateIsRevised;
            }
            else{
              _isRequested = true;
              _fatOtherDate = _tmpSSO.qualityIP.fatRequestedDate.getTime();
            }
            _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
              if (_equpList.includes(e.equipmentType)) {
                var temp: number = parseInt(e.panelQuantity, 10);
                if (temp > 0) {
                  _totalQtyFAT += temp;
                }
              }
            });
              let _fatDiff_time =  _fatOtherDate - _fatActual;
              let _fatDiff = _fatDiff_time / (1000 * 3600 * 24);
              ///FAT requested date Finalization Delay
              if (_fatDiff < 0) {
                _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                  if (_equpList.includes(e.equipmentType)) {
                    var temp: number = parseInt(e.panelQuantity, 10);
                    if (temp > 0) {
                      _delayQtyFAT += temp;
                    }
                  }
                });

                let _individualDelayQtyFat = 0;
                switch (_tmpSSO.pmTechSubSalesOrder.productVarient) {
                  case "001":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _delayQtyFATZS1 += temp;
                          _individualDelayQtyFat += temp;
                        }
                      }
                    });
                    break;
                  case "002":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _delayQtyFATZS1DBB += temp;
                          _individualDelayQtyFat += temp;
                        }
                      }
                    });

                    break;
                  case "003":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _delayQtyFATZS2 += temp;
                          _individualDelayQtyFat += temp;
                        }
                      }
                    });

                    break;
                  case "004":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _delayQtyFATZN1 += temp;
                          _individualDelayQtyFat += temp;
                        }
                      }
                    });

                    break;
                  case "005":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _delayQtyFATZS9 += temp;
                          _individualDelayQtyFat += temp;
                        }
                      }
                    });
                    break;
                }
                let _plannedTmp;
                let _revisedTmp;
                if(_isRevised!=null){
                  if(_isRevised == true){
                    _plannedTmp = null;
                    _revisedTmp = _tmpSSO.qualityIP.fatPlannedDate;
                  }
                  else{
                    _plannedTmp = _tmpSSO.qualityIP.fatPlannedDate;
                    _revisedTmp = null;
                  }
                }
                else{
                  _plannedTmp = null;
                  _revisedTmp = null;
                }
                let _requestedTmp = _isRequested==false?null:_tmpSSO.qualityIP.fatRequestedDate;

                _tmpSSOobj = new UiFunctionalKPI(_tmpSSO.planningIP.plannedManufacturingMonth, 'FAT requested date',_tmpSO.marketingIP.customerName , _tmpSO.marketingIP.salesOrderNo, _tmpSSO.subOrderNoId,
                _tmpSO.pmCommercial.isSaleOrderChangeApplicable, _tmpSO.pmCommercial.salesOrderNoNew, this._dataService.getProductVariantName(_tmpSSO.pmTechSubSalesOrder.productVarient), _individualDelayQtyFat, _plannedTmp, _revisedTmp,
                  _requestedTmp, _tmpSSO.qualityIP.fatActualDate, _fatDiff, _tmpSSO.qualityIP.fatActualToken.addNotes)
               
                  _tmpQualityKpi.push(_tmpSSOobj);
              }
              //FAT requested date on Time
              if (_fatDiff >= 0) {
                _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                  if (_equpList.includes(e.equipmentType)) {
                    var temp: number = parseInt(e.panelQuantity, 10);
                    if (temp > 0) {
                      _onTimeQtyFAT += temp;
                    }
                  }
                });

                let _individualOnTimeQtyFat = 0;
                switch (_tmpSSO.pmTechSubSalesOrder.productVarient) {
                  case "001":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _onTimeQtyFATZS1 += temp;
                          _individualOnTimeQtyFat += temp;
                        }
                      }
                    });
                    break;
                  case "002":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _onTimeQtyFATZS1DBB += temp;
                          _individualOnTimeQtyFat += temp;
                        }
                      }
                    });

                    break;
                  case "003":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _onTimeQtyFATZS2 += temp;
                          _individualOnTimeQtyFat += temp;
                        }
                      }
                    });

                    break;
                  case "004":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _onTimeQtyFATZN1 += temp;
                          _individualOnTimeQtyFat += temp;
                        }
                      }
                    });

                    break;
                  case "005":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _onTimeQtyFATZS9 += temp;
                          _individualOnTimeQtyFat += temp;
                        }
                      }
                    });
                    break;
                }
                let _plannedTmp;
                let _revisedTmp;
                if(_isRevised!=null){
                  if(_isRevised == true){
                    _plannedTmp = null;
                    _revisedTmp = _tmpSSO.qualityIP.fatPlannedDate;
                  }
                  else{
                    _plannedTmp = _tmpSSO.qualityIP.fatPlannedDate;
                    _revisedTmp = null;
                  }
                }
                else{
                  _plannedTmp = null;
                  _revisedTmp = null;
                }
                let _requestedTmp = _isRequested==false?null:_tmpSSO.qualityIP.fatRequestedDate;

                _tmpSSOobj = new UiFunctionalKPI(_tmpSSO.planningIP.plannedManufacturingMonth, 'FAT requested date',_tmpSO.marketingIP.customerName , _tmpSO.marketingIP.salesOrderNo, _tmpSSO.subOrderNoId,
                _tmpSO.pmCommercial.isSaleOrderChangeApplicable, _tmpSO.pmCommercial.salesOrderNoNew, this._dataService.getProductVariantName(_tmpSSO.pmTechSubSalesOrder.productVarient), _individualOnTimeQtyFat, _plannedTmp, _revisedTmp,
                _requestedTmp, _tmpSSO.qualityIP.fatActualDate, _fatDiff, _tmpSSO.qualityIP.fatActualToken.addNotes)
              
                  _tmpQualityKpi.push(_tmpSSOobj);
              }     


            }

            // Check for Green sticker Planned and Actual Dates

            if (_tmpSSO.qualityIP.greenStickerActualDate != null) {
              let _gsActual = _tmpSSO.qualityIP.greenStickerActualDate.getTime();
              let _isRevised = null;
              let _isRequested;
              let _gsOtherDate;
              if( _tmpSSO.qualityIP.greenStickerRequestedDate==null){
                _isRequested = false;
                _gsOtherDate = _tmpSSO.qualityIP.greenStickerPlannedDate.getTime();
                _isRevised = _tmpSSO.qualityIP.greenStickerPlannedDateIsRevised;
            }
            else{
              _isRequested = true;
              _gsOtherDate = _tmpSSO.qualityIP.greenStickerRequestedDate.getTime();
            }
            _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
              if (_equpList.includes(e.equipmentType)) {
                var temp: number = parseInt(e.panelQuantity, 10);
                if (temp > 0) {
                  _totalQtyGS += temp;
                  
                  
                }
              }
            });
              let _gsDiff_time =  _gsOtherDate - _gsActual;
              let _gsDiff = _gsDiff_time / (1000 * 3600 * 24);
              ///GS requested date Finalization Delay
              if (_gsDiff < 0) {
                _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                  if (_equpList.includes(e.equipmentType)) {
                    var temp: number = parseInt(e.panelQuantity, 10);
                    if (temp > 0) {
                      _delayQtyGS += temp;
                    }
                  }
                });

                let _individualDelayQtyGS = 0;
                switch (_tmpSSO.pmTechSubSalesOrder.productVarient) {
                  case "001":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _delayQtyGSZS1 += temp;
                          _individualDelayQtyGS += temp;
                        }
                      }
                    });
                    break;
                  case "002":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _delayQtyGSZS1DBB += temp;
                          _individualDelayQtyGS += temp;
                        }
                      }
                    });

                    break;
                  case "003":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _delayQtyGSZS2 += temp;
                          _individualDelayQtyGS += temp;
                        }
                      }
                    });

                    break;
                  case "004":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _delayQtyGSZN1 += temp;
                          _individualDelayQtyGS += temp;
                        }
                      }
                    });

                    break;
                  case "005":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _delayQtyGSZS9 += temp;
                          _individualDelayQtyGS += temp;
                        }
                      }
                    });
                    break;
                }
                let _plannedTmp;
                let _revisedTmp;
                if(_isRevised!=null){
                  if(_isRevised == true){
                    _plannedTmp = null;
                    _revisedTmp = _tmpSSO.qualityIP.greenStickerPlannedDate;
                  }
                  else{
                    _plannedTmp = _tmpSSO.qualityIP.greenStickerPlannedDate;
                    _revisedTmp = null;
                  }
                }
                else{
                  _plannedTmp = null;
                  _revisedTmp = null;
                }
                let _requestedTmp = _isRequested==false?null:_tmpSSO.qualityIP.greenStickerRequestedDate;

                _tmpSSOobj = new UiFunctionalKPI(_tmpSSO.planningIP.plannedManufacturingMonth, 'Green Sticker', _tmpSO.marketingIP.customerName , _tmpSO.marketingIP.salesOrderNo, _tmpSSO.subOrderNoId,
                _tmpSO.pmCommercial.isSaleOrderChangeApplicable, _tmpSO.pmCommercial.salesOrderNoNew, this._dataService.getProductVariantName(_tmpSSO.pmTechSubSalesOrder.productVarient), _individualDelayQtyGS, _plannedTmp, _revisedTmp,
                _requestedTmp, _tmpSSO.qualityIP.greenStickerActualDate, _gsDiff, _tmpSSO.qualityIP.greenStickerActualToken.addNotes)
               
                _tmpQualityKpi.push(_tmpSSOobj);
              }
              //GS requested date on Time
              if (_gsDiff >= 0) {
                _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                  if (_equpList.includes(e.equipmentType)) {
                    var temp: number = parseInt(e.panelQuantity, 10);
                    if (temp > 0) {
                      _onTimeQtyGS += temp;
                    }
                  }
                });

                let _individualOnTimeQtyGS = 0;
                switch (_tmpSSO.pmTechSubSalesOrder.productVarient) {
                  case "001":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _onTimeQtyGSZS1 += temp;
                          _individualOnTimeQtyGS += temp;
                        }
                      }
                    });
                    break;
                  case "002":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _onTimeQtyGSZS1DBB += temp;
                          _individualOnTimeQtyGS += temp;
                        }
                      }
                    });

                    break;
                  case "003":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _onTimeQtyGSZS2 += temp;
                          _individualOnTimeQtyGS += temp;
                        }
                      }
                    });

                    break;
                  case "004":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _onTimeQtyGSZN1 += temp;
                          _individualOnTimeQtyGS += temp;
                        }
                      }
                    });

                    break;
                  case "005":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _onTimeQtyGSZS9 += temp;
                          _individualOnTimeQtyGS += temp;
                        }
                      }
                    });
                    break;
                }
                let _plannedTmp;
                let _revisedTmp;
                if(_isRevised!=null){
                  if(_isRevised == true){
                    _plannedTmp = null;
                    _revisedTmp = _tmpSSO.qualityIP.greenStickerPlannedDate;
                  }
                  else{
                    _plannedTmp = _tmpSSO.qualityIP.greenStickerPlannedDate;
                    _revisedTmp = null;
                  }
                }
                else{
                  _plannedTmp = null;
                  _revisedTmp = null;
                }
                let _requestedTmp = _isRequested==false?null:_tmpSSO.qualityIP.greenStickerRequestedDate;

                _tmpSSOobj = new UiFunctionalKPI(_tmpSSO.planningIP.plannedManufacturingMonth, 'Green Sticker', _tmpSO.marketingIP.customerName , _tmpSO.marketingIP.salesOrderNo, _tmpSSO.subOrderNoId,
                _tmpSO.pmCommercial.isSaleOrderChangeApplicable, _tmpSO.pmCommercial.salesOrderNoNew, this._dataService.getProductVariantName(_tmpSSO.pmTechSubSalesOrder.productVarient), _individualOnTimeQtyGS, _plannedTmp, _revisedTmp,
                _requestedTmp, _tmpSSO.qualityIP.greenStickerActualDate, _gsDiff, _tmpSSO.qualityIP.greenStickerActualToken.addNotes)
              
                  _tmpQualityKpi.push(_tmpSSOobj);
              }     


            }
          });

        }


      }

    }

    if (_totalQtyME != 0 || _onTimeQtyME != 0 || _delayQtyME != 0) {
      this.totalDataME = [{
        "data": [{
          name: 'Total Panel Quantity',
          color: '#6e6e6e',
          y: _totalQtyME,
        },
        {
          name: 'On Time Panel',
          color: '#6e6e6e',
          y: _onTimeQtyME,
        },
        {
          name: 'Delayed Panel',
          color: '#6e6e6e',
          y: _delayQtyME,
        }]
      }

      ];
    }
    else { this.totalDataME = null; }

    this.totalDataKpiChartOptionsME = this._kpiCharServ.getTotalDataChartOptions(this.totalDataME);

    if (_onTimeQtyMEZN1 != 0 || _onTimeQtyMEZS9 != 0 || _onTimeQtyMEZS1 != 0 || _onTimeQtyMEZS1DBB != 0 || _onTimeQtyMEZS2 != 0
      || _delayQtyMEZN1 != 0 || _delayQtyMEZS9 != 0 || _delayQtyMEZS1 != 0 || _delayQtyMEZS1DBB != 0 || _delayQtyMEZS2 != 0) {

      this.panelWiseDataME = [{
        name: 'On Time',
        color: '#6e6e6e',
        type: 'column',
        data: [_onTimeQtyMEZN1, _onTimeQtyMEZS9, _onTimeQtyMEZS1, _onTimeQtyMEZS1DBB, _onTimeQtyMEZS2],
      },
      {
        name: 'Delay',
        color: '#ff000f',
        type: 'column',
        data: [_delayQtyMEZN1, _delayQtyMEZS9, _delayQtyMEZS1, _delayQtyMEZS1DBB, _delayQtyMEZS2],
      }

      ];
    }
    else { this.panelWiseDataME = null; }

    this.panelWiseKpiChartOptionsME = this._kpiCharServ.getPanelWiseChartOptions(this.panelWiseDataME);


    ////

    if (_totalQtyFAT != 0 || _onTimeQtyFAT != 0 || _delayQtyFAT != 0) {
      this.totalDataFAT = [{
        "data": [{
          name: 'Total Panel Quantity',
          color: '#6e6e6e',
          y: _totalQtyFAT,
        },
        {
          name: 'On Time Panel',
          color: '#6e6e6e',
          y: _onTimeQtyFAT,
        },
        {
          name: 'Delayed Panel',
          color: '#6e6e6e',
          y: _delayQtyFAT,
        }]
      }

      ];
    }
    else { this.totalDataFAT = null; }

    this.totalDataKpiChartOptionsFAT = this._kpiCharServ.getTotalDataChartOptions(this.totalDataFAT);

    if (_onTimeQtyFATZN1 != 0 || _onTimeQtyFATZS9 != 0 || _onTimeQtyFATZS1 != 0 || _onTimeQtyFATZS1DBB != 0 || _onTimeQtyFATZS2 != 0
      || _delayQtyFATZN1 != 0 || _delayQtyFATZS9 != 0 || _delayQtyFATZS1 != 0 || _delayQtyFATZS1DBB != 0 || _delayQtyFATZS2 != 0) {

      this.panelWiseDataFAT = [{
        name: 'On Time',
        color: '#6e6e6e',
        type: 'column',
        data: [_onTimeQtyFATZN1, _onTimeQtyFATZS9, _onTimeQtyFATZS1, _onTimeQtyFATZS1DBB, _onTimeQtyFATZS2],
      },
      {
        name: 'Delay',
        color: '#ff000f',
        type: 'column',
        data: [_delayQtyFATZN1, _delayQtyFATZS9, _delayQtyFATZS1, _delayQtyFATZS1DBB, _delayQtyFATZS2],
      }

      ];
    }
    else { this.panelWiseDataFAT = null; }

    this.panelWiseKpiChartOptionsFAT = this._kpiCharServ.getPanelWiseChartOptions(this.panelWiseDataFAT);

    ////

    if (_totalQtyGS != 0 || _onTimeQtyGS != 0 || _delayQtyGS != 0) {
      this.totalDataGS = [{
        "data": [{
          name: 'Total Panel Quantity',
          color: '#6e6e6e',
          y: _totalQtyGS,
        },
        {
          name: 'On Time Panel',
          color: '#6e6e6e',
          y: _onTimeQtyGS,
        },
        {
          name: 'Delayed Panel',
          color: '#6e6e6e',
          y: _delayQtyGS,
        }]
      }

      ];
    }
    else { this.totalDataGS = null; }

    this.totalDataKpiChartOptionsGS = this._kpiCharServ.getTotalDataChartOptions(this.totalDataGS);

    if (_onTimeQtyGSZN1 != 0 || _onTimeQtyGSZS9 != 0 || _onTimeQtyGSZS1 != 0 || _onTimeQtyGSZS1DBB != 0 || _onTimeQtyGSZS2 != 0
      || _delayQtyGSZN1 != 0 || _delayQtyGSZS9 != 0 || _delayQtyGSZS1 != 0 || _delayQtyGSZS1DBB != 0 || _delayQtyGSZS2 != 0) {

      this.panelWiseDataGS = [{
        name: 'On Time',
        color: '#6e6e6e',
        type: 'column',
        data: [_onTimeQtyGSZN1, _onTimeQtyGSZS9, _onTimeQtyGSZS1, _onTimeQtyGSZS1DBB, _onTimeQtyGSZS2],
      },
      {
        name: 'Delay',
        color: '#ff000f',
        type: 'column',
        data: [_delayQtyGSZN1, _delayQtyGSZS9, _delayQtyGSZS1, _delayQtyGSZS1DBB, _delayQtyGSZS2],
      }

      ];
    }
    else { this.panelWiseDataGS = null; }

    this.panelWiseKpiChartOptionsGS = this._kpiCharServ.getPanelWiseChartOptions(this.panelWiseDataGS);



    

    this.filteredSOCount = _tmpSOCounter;
    this.filteredSSOCount = _tmpSSOCounter;
    this.QualityKpi = _tmpQualityKpi;


    this.isDataViewUpdated4 = true;
    setTimeout(() => {
      this.isDataViewUpdated4 = false;
    }, 1000);
  }


  getManfMonthLabel(): string {
    if (this.isManfMonthFilterSelectedKpi9 == true) {
      return "Manufacturing Month : ";
    }
    else {
      return "Enable Manufacturing Month Filter";
    }
  }

  getManfFromMonthName(): string {
    if (this.manfMonthFilterKpi9) {
      return this.manfMonthFilterKpi9.fromMonthName;
    }
    return '';
  }
  getManfToMonthName(): string {
    if (this.manfMonthFilterKpi9) {
      return this.manfMonthFilterKpi9.toMonthName;
    }
    return '';
  }

  manfPrevFromMonth() {
    this.manfMonthFilterKpi9.prevFromMonth();
    this.filterRows();
  }
  manfNextFromMonth() {
    this.manfMonthFilterKpi9.nextFromMonth();
    this.filterRows();
  }
  manfPrevToMonth() {
    this.manfMonthFilterKpi9.prevToMonth();
    this.filterRows();
  }
  manfNextToMonth() {
    this.manfMonthFilterKpi9.nextToMonth();
    this.filterRows();
  }

  private getFilteredSubOrders(_ssoAr: Array<SubSalesOrder>): Array<SubSalesOrder> {
    return _ssoAr.filter((_sso: SubSalesOrder) => {
      //check for failure cases
      //dont show if sub order is dispatched
      if (_sso.isSSOStatusSet(SSOStatus.Dispatched) == true) return false;

      //check if mfg month 
      if (this.isManfMonthFilterPassed(_sso.manufacturingMonth) == false) return false;
      return true;
    });
  }


  private isManfMonthFilterPassed(_manfMonth: Date) {
    if (this.isManfMonthFilterSelectedKpi9 == true && this.manfMonthFilterKpi9 != null) {
      if (this.manfMonthFilterKpi9.isWithInFilterScope(_manfMonth) == false) {
        return false;
      }
    }
    return true;
  }

}
